<form>
  <div *ngIf="column.filter.type == filterType.Text" class="filter-text">
    <mat-form-field appearance="outline" color="primary">
      <input matInput type="text" [formControl]="textFormControl" (keyup)="filterData()" autocomplete="off">
    </mat-form-field>
  </div>

  <div *ngIf="column.filter.type == filterType.Number" class="filter-number">
    <mat-form-field appearance="outline" color="primary">
      <input matInput type="text" [formControl]="numberFormControl" (numberChange)="filterData()" [numberMask]="true"
        autocomplete="off">
    </mat-form-field>
  </div>

  <div *ngIf="column.filter.type == filterType.Select">
    <mat-form-field appearance="outline" color="primary">
      <mat-select [formControl]="selectFormControl" (selectionChange)="filterData()" [disableOptionCentering]="true">
        <mat-option *ngFor="let option of column.filter.options" [value]="option.value">{{option.name | translate}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="column.filter.type == filterType.MultipleSelect" class="multipleSelect">
    <mat-form-field appearance="outline" color="primary">
      <span matPrefix >({{ multipleSelectFormControl.value?.length || 0 }})</span>
      <mat-select [formControl]="multipleSelectFormControl" multiple (closed)="filterData()" [disableOptionCentering]="true">
        <mat-option *ngFor="let option of column.filter.options" [value]="option.value">
          <span [innerHTML]="option.name"></span>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  
  <div *ngIf="column.filter.type == filterType.Boolean">
    <mat-select [formControl]="booleanFormControl" (selectionChange)="filterData()" [disableOptionCentering]="true">
      <mat-option *ngFor="let option of column.filter.options" [value]="option.value">{{option.name |
        translate}}</mat-option>
    </mat-select>
  </div>
</form>